class ImpersonationApi {
  constructor (pgConnection, agaveAdapter, logger) {
    this.pgConnection = pgConnection
    this.agaveAdapter = agaveAdapter
    this.logger = logger
  }

  start ({ type, target }) {
    return this.agaveAdapter.create('impersonation/start', { type, target })
  }

  stop () {
    return this.agaveAdapter.delete('impersonation/stop')
  }

  async recordStart ({ tokenId, impersonator, type, targetLocationUuid }) {
    await this.pgConnection.query(`
      INSERT INTO avocado.data_impersonation_events
        (token_id, impersonator, type, target_location_uuid)
      VALUES ($1, $2, $3, $4)
    `, [tokenId, impersonator, type, targetLocationUuid])
  }

  async recordStop (tokenId) {
    await this.pgConnection.query(`
      UPDATE avocado.data_impersonation_events
      SET ended_at = NOW()
      WHERE token_id = $1 AND ended_at IS NULL
    `, [tokenId])
  }

  async isRevoked (tokenId) {
    const { rows } = await this.pgConnection.query(`
      SELECT 1 FROM avocado.data_impersonation_events
      WHERE token_id = $1 AND ended_at IS NOT NULL
    `, [tokenId])
    return rows.length > 0
  }
}

module.exports = ImpersonationApi
